<mdb-card cascade="true" narrower="true">
   <mdb-card-body cascade="true" class="pb-2">
      <div class="text-center">
         <h4 class="pink-text"><i class="fa fa-tag"></i> {{ heading }}</h4>
      </div>
      <hr />
      <div class="d-flex justify-content-center">
         <mdb-spinner *ngIf="loading"></mdb-spinner>
      </div>

      <div>
         <div class="row" *ngIf="documents?.length == 0">
            <div class="col-md-12">No documents</div>
         </div>

         <div class="d-flex mx-2 my-1" *ngFor="let doc of documents">
            <button type="button" look="outline" title="Export Template" (click)="export(doc.id)" kendoButton [icon]="doc.icon" placement="left" class="ml-1 w-100 text-truncate">
               {{ doc.name }}
            </button>
            <button
               type="button"
               title="Export Template"
               (click)="openDelete(doc.id)"
               kendoButton
               [icon]="'trash'"
               placement="left"
               class="ml-1 text-truncate red white-text"
            ></button>
         </div>

         <kendo-upload
            *ngIf="showUpload"
            [saveUrl]="uploadSaveUrl"
            (upload)="uploadEventHandler($event)"
            [withCredentials]="false"
            (success)="successEventHandler($event)"
            (error)="errorEventHandler($event)"
            [restrictions]="fileRestrictions"
            [multiple]="false"
            [disabled]="!isValidBooking"
         >
         </kendo-upload>
      </div>
   </mdb-card-body>
</mdb-card>
<kendo-dialog *ngIf="deleteOpened" (close)="closeDelete()" [@fadeInOnEnter]>
   <kendo-dialog-titlebar>
      <div style="font-size: 18px; line-height: 1.3em"><span class="k-icon k-i-warning"></span> Delete Document</div>
   </kendo-dialog-titlebar>
   <div>
      <mdb-card cascade="true" narrower="true">
         <div class="d-flex">
            <div style="margin: 30px; text-align: center">
               <p>
                  <kendo-icon class="animate__animated animate__rotateIn" name="close" themeColor="error" size="xxxlarge"></kendo-icon> Are you sure you want to delete the
                  document?
               </p>
               <p>
                  <small class="grey-text">The document will be removed completely from the system</small>
               </p>
            </div>
         </div>
      </mdb-card>
   </div>
   <kendo-dialog-actions layout="normal">
      <div class="d-flex justify-content-center w-100">
         <mdb-spinner *ngIf="loadingDelete"></mdb-spinner>
      </div>
      <div *ngIf="!loadingDelete" class="d-flex justify-content-around w-100">
         <button kendoButton (click)="closeDelete()">Cancel</button>
         <button kendoButton (click)="delete()" class="text-danger">Delete</button>
      </div>
   </kendo-dialog-actions></kendo-dialog
>
